// extracted by mini-css-extract-plugin
export default {"sliderEmptyState":"m6E038"};